/**
 * US-92: единый формат часов в таблицах и карточках: «40», «7,5», «4,25» —
 * запятая как десятичный разделитель, хвостовые нули обрезаются.
 * До этого вперемешку: «40.00» (сырая строка API) и «40,0» (грид таймшита).
 */
export function formatHours(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === "") return "";
  const n = typeof value === "string" ? parseFloat(value) : value;
  if (Number.isNaN(n)) return String(value);
  const rounded = Math.round(n * 100) / 100;
  return String(rounded).replace(".", ",");
}

/**
 * US-113: ставка всегда с двумя знаками и запятой — «0,50», «1,00». В отличие
 * от часов хвостовые нули не обрезаются: так ставку пишут в приказах.
 */
export function formatRate(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === "") return "";
  const n = typeof value === "string" ? parseFloat(value) : value;
  if (Number.isNaN(n)) return String(value);
  return n.toFixed(2).replace(".", ",");
}
